import { CourseSubtitleData } from "../../models/courseData";

/**
 * Represents the state for course subtitles in the Redux store.
 */
export interface CourseSubtitleState {
  courseSubtitles: CourseSubtitleData[];
  isLoading: boolean;
  courseSubtitlesLoaded: boolean;
  error: boolean;
}

/**
 * Action type dispatched when course subtitle request starts.
 */
export const COURSE_SUBTITLES_REQUEST = "COURSE_SUBTITLES_REQUEST";

/**
 * Action type dispatched when course subtitles are successfully fetched.
 */
export const COURSE_SUBTITLES_SUCCESS = "COURSE_SUBTITLES_SUCCESS";

/**
 * Action type dispatched when there is an error fetching course subtitles.
 */
export const COURSE_SUBTITLES_FAILURE = "COURSE_SUBTITLES_FAILURE";

/**
 * Action for initiating a course subtitle fetch request.
 */
export interface CourseSubtitlesRequestAction {
  type: typeof COURSE_SUBTITLES_REQUEST;
}

/**
 * Action for handling a failed course subtitle fetch request.
 */
export interface CourseSubtitlesFailureAction {
  type: typeof COURSE_SUBTITLES_FAILURE;
}

/**
 * Action for handling a successful course subtitle fetch.
 */
export interface CourseSubtitlesSuccessAction {
  type: typeof COURSE_SUBTITLES_SUCCESS;
  data: CourseSubtitleData[];
}

/**
 * Union type for all possible course subtitle action types.
 */
export type CourseSubtitleActionTypes =
  | CourseSubtitlesRequestAction
  | CourseSubtitlesSuccessAction
  | CourseSubtitlesFailureAction;
